import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisMembersSalesConceptSearchItemsIndexResponseType } from "../../types";

const request =
  async (): Promise<ApisMembersSalesConceptSearchItemsIndexResponseType> => {
    const response =
      await new ApiClient().get<ApisMembersSalesConceptSearchItemsIndexResponseType>(
        "/api/members/sales_concept_search_items",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersSalesConceptSearchItemsIndex = ({
  config = {},
}: PropsType): UseQueryResult<ApisMembersSalesConceptSearchItemsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersSalesConceptSearchItemsIndex"],
    queryFn: () => request(),
  });
};
